import api from "@/api";
import { PAGINATION_DEFAULT } from "@/const";
import { formatArrayToElSelect } from "@/utils";

const state = {
  listProspects: [],
  status: "",
  indexUrl: "/api/prospects",
  pagination: PAGINATION_DEFAULT,
  dataCache: [],
  defaultHttpParams: {}
};

const getters = {
  isLoading: (state) => {
    return state.status === "loading";
  },
  listProspects: (state) => {
    return formatArrayToElSelect(state.listProspects, {
      label: "CompanyName",
      value: "ContactCode"
    });
  }
};

const mutations = {
  SET_LOADING: (state) => {
    state.status = "loading";
  },
  SET_SUCCESS: (state) => {
    state.status = "success";
  },
  SET_ERROR: (state) => {
    state.status = "error";
  },
  SET_LIST_PROSPECTS: (state, prospects) => {
    state.listProspects = prospects;
  },
  SET_PAGINATION: (state, pagination) => {
    state.pagination = pagination;
  },
  SET_DEFAULT_HTTP_PARAMS: (state, params) => {
    state.defaultHttpParams = params;
  },
  DELETE_PROSPECTS: (state, { phaseId, deal }) => {
    const index = state.dealsDB[phaseId].findIndex((f) => f.Id === deal.Id);
    state.dealsDB[phaseId].splice(index, 1);
  }
};

const actions = {
  getProspects: (context, payload) => {
    return new Promise((resolve, reject) => {
      context.commit("SET_LOADING");
      context.commit("SET_DEFAULT_HTTP_PARAMS", payload);

      api
        .get(context.state.indexUrl, payload)
        .then((response) => {
          const {
            data: { Items, ItemCount, CurrentPage }
          } = response;

          context.commit("SET_SUCCESS");
          context.commit("SET_LIST_PROSPECTS", Items);
          context.commit("SET_PAGINATION", {
            ...PAGINATION_DEFAULT,
            total: ItemCount,
            currentPage: CurrentPage
          });
          resolve(response);
        })
        .catch((error) => {
          context.commit("SET_ERROR");
          reject(error);
        });
    });
  },
  /**
   * Esta accion pagina items del lado del frontend.
   * Importante: si quieres invocar esto sin parametros, se debe
   * pasar un {Object} vacio.
   *
   * @name paginate
   * @param {Number} current_page - Pagina a la cual se quiere navegar.
   * @param {Number} page_size - Cantidad de linea por pagina.
   */
  async paginate({ state, commit, dispatch }, { current_page, page_size }) {
    commit("SET_LOADING");

    try {
      // copiar defaultHttpParams
      let config = JSON.parse(JSON.stringify(state.defaultHttpParams));
      if (config["params"] === undefined) {
        config.params = {};
      }

      config.params.Page = current_page ?? state.pagination.currentPage;
      config.params.Limit = page_size ?? state.pagination.pageSize;

      commit("SET_DEFAULT_HTTP_PARAMS", config);

      await dispatch("getProspects", config);

      return Promise.resolve(true);
    } catch (error) {
      commit("SET_ERROR");
      return Promise.reject(error);
    }
  },
  async searchProspects({ state, dispatch, commit }, { search }) {
    try {
      commit("SET_LOADING");

      // copiar defaultHttpParams
      let config = JSON.parse(JSON.stringify(state.defaultHttpParams));
      if (config["params"] === undefined) {
        config.params = {};
      }

      config.params.Search = search;

      commit("SET_DEFAULT_HTTP_PARAMS", config);

      await dispatch("getProspects", config);

      return Promise.resolve(true);
    } catch (error) {
      commit("SET_ERROR");

      if (error.message.includes("404")) {
        return Promise.reject("404");
      }

      return Promise.reject(error);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
